@let isColorPaleteActivated = isColorPaleteActivated$ | async;
<div class="toolbar-button-container">
    <svg class="selected-color"
         viewBox="0 0 100 100"
         preserveAspectRatio="xMidYMid meet">
        <circle [attr.fill]="strokeColor$ | async"></circle>
    </svg>
    <pcp-slide-sync-toolbar-button
            class="toolbar-button"
            [matIcon]="icon"
            [fontSet]="fontSet"
            (toggle)="toggleColorPalette()"
            [turnedOn]="isColorPaleteActivated === true"
            [disabled]="(isDrawingEnabled$ | async) === false"
            (pcpClickOutside)="isColorPaleteActivated ? hideColorPalette() : {}"
    ></pcp-slide-sync-toolbar-button>
    <app-color-palette
        class="toolbar-menu-overlay"
        [ngClass]="{ hidden: !isColorPaleteActivated }"
    ></app-color-palette>
</div>
